import React from "react"
import GetSpace from "../../utils/space"
import { TitleChildrenPath, TitlePageResponsiveIconSmall } from "../Titles/Titles"
import { type IconProp } from "@fortawesome/fontawesome-svg-core"
import { faAngleDown, faAngleUp, faCaretRight, faFile, faTicket, faUserPen } from "@fortawesome/free-solid-svg-icons"
import style from "./DetailsItems.module.css"
import { useExpansive } from "../../hooks/useExpansive"
import { ButtonIcon } from "../Button/Button"
import defalutStyle from "../../styles/defaultPageStyle.module.css"
import { CardEmployeeRegisterInLine } from "../CardEmployeeRegister/CardEmployeeRegister"
import { employeeMemory } from "../../Objects/Memory/Memory"
import { convertToLocalMoney } from "../../Objects/Generics/Helps"
import { SIZE } from "../../configuration/Sizes"
import THEME from "../../configuration/Theme"
import { GenericOrderFoodAdditionalEntity } from "../../Objects/Order/GenericOrderFoodAdditionalEntity"
import { BasicCard } from "../BasicCard/BasicCard"

interface DetailsItemsProps {
  name: string
  icon: IconProp
  coast: number
  details: string
  canShowAll: boolean
  date: string
  employeeId: number
  iconColor: string
  addtionals: GenericOrderFoodAdditionalEntity[]
  selections: any[]
}

export const DetailsItems: React.FC<DetailsItemsProps> = ({
  date,
  name,
  iconColor,
  icon,
  coast,
  details,
  canShowAll,
  employeeId,
  addtionals,
  selections,
}) => {
  const { handleChangeState, expansive } = useExpansive()

  return (
    <div className="rounded-lg border border-orange-100 bg-gradient-to-br from-white via-orange-50 to-orange-100/40 p-2 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md">
      <GetSpace top={5} />

      <TitleChildrenPath
        title={name}
        icon={icon}
        boxShadow="none"
        sizeProp="sm"
        iconColor={iconColor}
        subtitleChildren={
          <div className={style.divRow}>
            <BasicCard borderColor={THEME.colors.white} title={convertToLocalMoney(coast)} />

            {canShowAll && (
              <>
                <GetSpace left={5} />

                <ButtonIcon
                  typeButton="button"
                  sizeNumber={SIZE.buttonExpandIcon}
                  bgColor={THEME.colors.buttonBGExpandColor}
                  iconColor={THEME.colors.buttonFGExpandColor}
                  icon={!expansive ? faAngleDown : faAngleUp}
                  onClick={handleChangeState}
                  size="small"
                  descriptionKey="interactionDescriptions:components.detailsItems.detailsItems.button.handleChangeState"
                />
              </>
            )}
          </div>
        }
        children={
          <>
            {expansive && (
              <>
                <GetSpace top={10} />

                <CardEmployeeRegisterInLine
                  employee={employeeMemory.findById(employeeId)!}
                  color={THEME.colors.colorEmployeeCard}
                  date={date}
                  icon={faUserPen}
                />

                <GetSpace top={10} />

                {addtionals.length > 0 &&
                  addtionals.map((e) => {
                    return (
                      <>
                        <TitlePageResponsiveIconSmall
                          boxShadow="none"
                          icon={faCaretRight}
                          iconColor={THEME.colors.iconBGColor}
                          title={e.addtionalEntity.name}
                          sizeProp="sm"
                          children={
                            <BasicCard
                              title={e.amount.toString() + " x " + e.valueTotal.toString().toMoney()}
                              borderColor={THEME.colors.white}
                            />
                          }
                        />

                        <GetSpace top={5} />
                      </>
                    )
                  })}

                {selections.length > 0 &&
                  selections.map((selection, index) => {
                    return (
                      <React.Fragment key={selection.selectionEntityId ?? index}>
                        <TitlePageResponsiveIconSmall
                          boxShadow="none"
                          icon={faCaretRight}
                          iconColor={THEME.colors.iconBGColor}
                          title={selection.selectionEntity?.name ?? "Seleção"}
                          sizeProp="sm"
                          children={
                            <BasicCard
                              title={`${selection.selectionOptionEntity?.name ?? "Opção"} • ${Number(
                                selection.value ?? selection.selectionOptionEntity?.value ?? 0,
                              )
                                .toString()
                                .toMoney()}`}
                              borderColor={THEME.colors.white}
                            />
                          }
                        />

                        <GetSpace top={5} />
                      </React.Fragment>
                    )
                  })}

                {details.length > 0 && (
                  <>
                    <GetSpace top={10} />

                    <TitleChildrenPath
                      icon={faFile}
                      boxShadow="none"
                      title="Detalhes"
                      iconColor={THEME.colors.iconBGSecondaryColor}
                      children={
                        <textarea
                          onChange={() => {}}
                          className={style.textarea}
                          value={details}
                          data-interaction-description-key="interactionDescriptions:components.detailsItems.detailsItems.input.input"
                        />
                      }
                    />
                  </>
                )}

                <div className={defalutStyle.divisionBar}></div>

                <GetSpace top={10} />
              </>
            )}
          </>
        }
      />
    </div>
  )
}
